import UserAPI from '@/api/users';

export default {
    namespaced: true,
    state(){
        return {
            users: [],
            cuser: []
        }
    },
    getters:{
    },
    actions:{
        async getUser({state, commit}, uid){
            const key = `U${uid}`;
            if(!state.users[key]){
                const response = await UserAPI.getUserById(uid);
                if(response.status && response.result){
                    commit('setUser', {uid, user: response.result});
                }
            }
            return state.users[key] ?? null;
        },
        async getCurUser({state, commit}){
            if(!state.cuser.length){
                const user = await UserAPI.getUser();
                commit('setCUser', {user: user.result});
            }
            return state.cuser;
        }
    },
    mutations:{
        setUser(state, {uid, user}){
            state.users[`U${uid}`] = user;
        },
        setCUser(state, {user}){
            state.cuser = user;
        },
    }
  }